module.exports = __webpack_public_path__ + "img/main.f18b5afd.jpg";